import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RoutePath } from 'src/routes/types';

import { initialState } from './initialState';

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setSegments: (state, action: PayloadAction<RoutePath[]>) => {
      state.segments = action.payload;
    },
  },
});

export const { actions: navigationActions, reducer: navigationReducer } =
  navigationSlice;
